import { BASE_URL } from "../../../../Constant";

export const API_BUSINESS_SERVICE_SUB_CATEGORY_SAVE_SUB_CATEGORY: string = BASE_URL + '/api/businessServiceSubCategory'; 
export const API_LOAD_BY_BUSINESS_SERVICE_SUB_CATEGORY_ID: string = BASE_URL + '/api/BusinessServiceSubCategory'; 
export const API_LOAD_BY_BUSINESS_SERVICE_SUB_CATEGORY_FOR_BUSINESS_SERVICE_ID: string = BASE_URL + '/api/BusinessServiceSubCategory/businessServiceId'; 